export function DestinationPacketsTemplatePreviewPage() {
  return (
    <div>
      <h1>Preview Destination Packet Template</h1>
      <p>Preview template page - coming soon</p>
    </div>
  );
}

